jQuery('.facet-btn').click(function() {
    let isThisOpen = jQuery(this).hasClass('open');
    jQuery('.facet-btn.open').each(function() {
      jQuery(this).removeClass('open');
    });
    if ( !isThisOpen ) {
      jQuery(this).toggleClass('open');

      jQuery('#main').click(function() {
        
      });
    }
});

jQuery('.facetwp-facet-woocommerce_koko').click(function() {
    facetCounter();
});

jQuery('.facetwp-facet-woocommerce_vari').click(function() {
    facetCounter();
});

function facetCounter() {
  document.addEventListener('facetwp-loaded', function() {
    if(jQuery(".facetwp-facet-woocommerce_koko .facetwp-checkbox.checked").length > 0) {
      jQuery('.koko_counter').text('(' + jQuery(".facetwp-facet-woocommerce_koko .facetwp-checkbox.checked").length + ')');
      jQuery("li[data-facet='woocommerce_koko'] .facetwp-selection-value").click(function() {
        facetCounter();
      });
    } else {
      jQuery('.koko_counter').text('');
    }

    if(jQuery(".facetwp-facet-woocommerce_vari .facetwp-checkbox.checked").length > 0) {
      jQuery('.vari_counter').text('(' + jQuery(".facetwp-facet-woocommerce_vari .facetwp-checkbox.checked").length + ')');
      jQuery("li[data-facet='woocommerce_vari'] .facetwp-selection-value").click(function() {
        facetCounter();
      });
    } else {
      jQuery('.vari_counter').text('');
    }
  });
}

jQuery( window ).resize(function() {
  filterToggle();
});

jQuery( window ).load(function() {
  filterToggle();
});

function filterToggle() {
  if( jQuery(window).width() < 767 ) {
    jQuery('.woocommerce__filters-left svg').click(function() {
      jQuery('body').addClass('no-scroll');
      jQuery('.woocommerce__filters-container').addClass('open');
      jQuery('.close--rajaus-popup').click(function() {
        jQuery('.woocommerce__filters-container').removeClass('open');
        jQuery('body').removeClass('no-scroll');
      });
      jQuery('.results-btn').click(function() {
        jQuery('.woocommerce__filters-container').removeClass('open');
        jQuery('body').removeClass('no-scroll');
      });
    }); 
  }
}